import {io} from "socket.io-client";

const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:7004/api/v1/competition";

/** Socket server origin — strip `/api/v1/competition` from API base. */
export const getSocketOrigin = () => {
  const raw = process.env.REACT_APP_SOCKET_URL || API_BASE;
  try {
    const url = new URL(raw);
    return url.origin;
  } catch {
    return String(raw)
      .replace(/\/api\/v1\/competition\/?$/i, "")
      .replace(/\/$/, "") || "http://localhost:7004";
  }
};

const getLandingUrl = () => {
  if (typeof window === "undefined" || !window.location?.origin) return "";
  return window.location.origin;
};

let sharedSocket = null;

/**
 * Shared Socket.IO client for live leaderboard (MT5-style ticks).
 */
export const getLeaderboardSocket = () => {
  if (sharedSocket) return sharedSocket;

  const landingUrl = getLandingUrl();
  sharedSocket = io(getSocketOrigin(), {
    path: "/socket.io",
    transports: ["websocket", "polling"],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 8000,
    query: landingUrl ? { landingUrl } : undefined,
  });

  return sharedSocket;
};

export const LEADERBOARD_SOCKET_EVENTS = {
  snapshot: "leaderboard:snapshot",
  update: "leaderboard:update",
  subscribe: "leaderboard:subscribe",
  unsubscribe: "leaderboard:unsubscribe",
};
